import { Action, handleActions } from 'redux-actions'
import { ActivityProgress, BadgeDto, CompanyCountriesDto, DivisionDto, PeriodType } from '../../../services/api.types'
import {
  getUserCompanyCountriesSuccess,
  getCompanyDivisionsSuccess,
  //getUserActivitySuccess,
  //getUserBadgesSuccess,
} from './SettingsActions'

class State {
  activity: ActivityProgress = {
    actualMaxHeartRate: 0,
    calculatedMaxHeartRate: 0,
    caloriesGoal: 0,
    caloriesPercentage: 0,
    caloriesProjectedPercentage: 0,
    caloriesTotal: 0,
    divisionName: '',
    country: '',
    lastSync: 0,
    email: '',
    endDate: 0,
    firstName: '',
    goalId: '',
    intensiveMinutesGoal: 0,
    intensiveMinutesPercentage: 0,
    intensiveMinutesProjectedPercentage: 0,
    intensiveMinutesTotal: 0,
    lastName: '',
    ofPeriodPassedPercentage: 0,
    startDate: 0,
    stepsGoal: 0,
    stepsPercentage: 0,
    stepsProjectedPercentage: 0,
    stepsTotal: 0,
    totalPercentage: 0,
    totalProjectedPercentage: 0,
    userId: '',
    period: PeriodType.MONTH,
    persistenceGoal: 0,
    persistencePercentage: 0,
    persistenceTotal: 0,
  }

  badges: BadgeDto[] = []

  countries: CompanyCountriesDto[] = []

  divisions: DivisionDto[] = []
}

export const settings = handleActions<State, any>(
  {
    /*[String(getUserActivitySuccess)]: (state: State, { payload }: any): State => ({
      ...state,
      activity: payload,
    }),*/
    /*[String(getUserBadgesSuccess)]: (state: State, { payload = [] }: Action<BadgeDto[]>): State => ({
      ...state,
      badges: payload,
    }),*/
    [String(getUserCompanyCountriesSuccess)]: (
      state: State,
      { payload = [] }: Action<CompanyCountriesDto[]>,
    ): State => ({
      ...state,
      countries: payload,
    }),
    [String(getCompanyDivisionsSuccess)]: (state: State, { payload = [] }: Action<DivisionDto[]>): State => ({
      ...state,
      divisions: payload,
    }),
  },
  new State(),
)

export { State as SettingsState }
